<template>
  <footer class="footer full-width">
    <div class="footer-container full-width-container">
      <!-- Main Footer Content -->
      <div class="footer-main">
        <div class="footer-section brand-section">
          <div class="footer-logo">
            <img
              src="@/assets/logo.png"
              alt="Africa HR Summit Logo"
              class="logo-image"
            />
            <h3 class="footer-brand-title text-xl">
              AFRICA HUMAN RESOURCE SUMMIT (AHRS)
            </h3>
          </div>
          <p class="footer-description">
            The Africa Human Resource Summit (AHRS) is the premier pan-African
            platform dedicated to shaping the future of work across the
            continent. The Summit convenes HR experts and professionals from
            across Africa to engage, learn, and collaborate on emerging trends
            and best practices. AHRS offers the largest and most influential
            networking environment for HR professionals in Africa, enabling
            strategic connections, knowledge sharing, and impactful
            partnerships.
          </p>
          <div class="social-links">
            <a href="https://www.facebook.com/afrihrsummit2026" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Facebook">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </a>
            <a href="https://x.com/AfricaHRSummit" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="X (formerly Twitter)">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/afrihrsummit/" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="LinkedIn">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                />
              </svg>
            </a>
            <a href="https://www.instagram.com/afrihrsummit2026/" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Instagram">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
            <a href="https://wa.me/255745004005" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="WhatsApp">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"
                />
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-section">
          <h4 class="footer-section-title text-lg">Quick Links</h4>
          <ul class="footer-links">
            <li>
              <router-link to="/visa" class="footer-link">VISA</router-link>
            </li>
            <li>
              <router-link to="/travel" class="footer-link">TRAVEL</router-link>
            </li>
          </ul>
        </div>

        <div class="footer-section">
          <h4 class="footer-section-title text-lg">Event Info</h4>
          <div class="event-info">
            <div class="info-item">
              <svg
                class="info-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <div class="info-content">
                <strong>Date:</strong>
                <span>19-22 August 2026</span>
              </div>
            </div>
            <div class="info-item">
              <svg
                class="info-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <div class="info-content">
                <strong>Venue:</strong>
                <div class="venue-location">
                  <div>Mount Meru Hotel</div>
                  <div>Arusha, Tanzania</div>
                </div>
              </div>
            </div>
            <div class="info-item">
              <svg
                class="info-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="m4.93 4.93 4.24 4.24"></path>
                <path d="m14.83 9.17 4.24-4.24"></path>
                <path d="m14.83 14.83 4.24 4.24"></path>
                <path d="m9.17 14.83-4.24 4.24"></path>
              </svg>
              <div class="info-content">
                <strong>Theme:</strong>
                <span>"Transforming Africa's Workforce for the Future"</span>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-section">
          <h4 class="footer-section-title text-lg">Contact Information</h4>
          <div class="contact-info">
            <div class="contact-item">
              <strong>Email:</strong>
              <a href="mailto:register@africahrsummit.org" class="contact-link">
                register@africahrsummit.org
              </a>
            </div>
            <div class="contact-item">
              <strong>Website:</strong>
              <a
                href="https://www.africahrsummit.org"
                class="contact-link"
                target="_blank"
              >
                www.africahrsummit.org
              </a>
            </div>
            <div class="contact-item">
              <svg
                class="contact-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <div class="contact-content">
                <strong>Location:</strong>
                <div class="venue-location">
                  <div>Mount Meru Hotel</div>
                  <div>Arusha, Tanzania</div>
                </div>
              </div>
            </div>
          </div>

          <button class="footer-cta-btn" @click="handleRegistration">
            Register Now
          </button>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <div class="copyright">
            <p>&copy; 2026 AHRS. All rights reserved.</p>
          </div>
          <!-- <div class="footer-bottom-links">
            <a href="#" class="footer-bottom-link">Privacy Policy</a>
            <a href="#" class="footer-bottom-link">Terms of Service</a>
            <a href="#" class="footer-bottom-link">Cookie Policy</a>
          </div> -->
          <div class="powered-by">
            <p>
              Powered by
              <a href="https://www.ahrcafrica.com/" target="_blank" rel="noopener noreferrer" class="powered-link"
                >African Human Resource Confederation</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  methods: {
    scrollToSection(sectionId) {
      // Handle home section - scroll to top
      if (sectionId === "home") {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      // For other sections, scroll to the element
      this.smoothScrollToElement(sectionId);
    },
    smoothScrollToElement(sectionId) {
      setTimeout(() => {
        const element = document.querySelector(`.${sectionId}-section`);
        if (element) {
          const offsetTop = element.offsetTop - 100; // Account for fixed header
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
        }
      }, 100);
    },
    handleRegistration() {
      this.$router.push("/registration");
    },
  },
};
</script>

<style scoped>
.footer {
  background: var(--color-primary-dark);
  color: white;
  padding-top: 60px;
}

.footer-container {
  width: 100%;
  margin: 0 auto;
}

.footer-main {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section h4.footer-section-title {
  color: var(--color-primary-light);
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: bold;
}

/* Brand Section */
.footer-logo {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.logo-image {
  width: 50px;
  height: 50px;
  background: white;
  border-radius: var(--radius-lg);
  padding: 8px;
}

.footer-brand-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: var(--color-primary-light);
  margin: 0;
}

.footer-description {
  line-height: 1.6;
  margin-bottom: 25px;
  color: rgba(255, 255, 255, 0.9);
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: var(--color-primary-light);
  transform: translateY(-3px);
}

.social-icon {
  width: 18px;
  height: 18px;
  color: white;
}

/* Footer Links */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: var(--color-primary-light);
}

/* Event Info */
.info-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
}

.info-icon {
  width: 20px;
  height: 20px;
  color: var(--color-primary-light);
  flex-shrink: 0;
  margin-top: 2px;
}

.info-content {
  display: flex;
  flex-direction: column;
}

.info-item strong {
  color: var(--color-primary-light);
  margin-bottom: 5px;
  font-size: 0.9rem;
}

.info-item span {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  line-height: 1.4;
}

/* Contact Info */
.contact-info {
  margin-bottom: 25px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
}

.contact-icon {
  width: 20px;
  height: 20px;
  color: var(--color-primary-light);
  flex-shrink: 0;
  margin-top: 2px;
}

.contact-content {
  display: flex;
  flex-direction: column;
}

.contact-item strong {
  color: var(--color-primary-light);
  margin-bottom: 5px;
  font-size: 0.9rem;
}

.contact-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: var(--color-primary-light);
}

.footer-cta-btn {
  background: var(--gradient-cta);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: var(--radius-lg);
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-cta-btn:hover {
  background: var(--gradient-hover);
  transform: translateY(-2px);
}

/* Footer Bottom */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 25px 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.copyright p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.footer-bottom-links {
  display: flex;
  gap: 25px;
}

.footer-bottom-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-bottom-link:hover {
  color: var(--color-primary-light);
}

.powered-by p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.powered-link {
  color: var(--color-primary-light);
  text-decoration: none;
  font-weight: bold;
}

.powered-link:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-main {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .footer-bottom-links {
    justify-content: center;
  }

  .social-links {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer {
    padding-top: 40px;
  }

  .footer-logo {
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 10px;
  }

  .footer-description {
    text-align: center;
  }
}

.venue-location {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.venue-location div {
  margin: 0;
}
</style>
